const parseJson = async response => {
    const text = await response.text();
    try {
        const json = JSON.parse(text);
        return json;
    } catch (err) {
        return text;
    }
};

/**
 * Shopify API Helper
 * 
 * Handles the formatting of the URL and actioning the fetch function
 * 
 * @param   {String} clientKey      The client key to fetch blob data
 * @param   {String} instanceKey    The instance key to obtain Shopify keys from
 * @param   {String} endpoint       The Shopify API endpoint you need to call.
 * @param   {String} method         (Optional) The method for the call. Valid options are GET, POST, PUT, DELETE. Defaults to GET.
 * @param   {String|Object} body    (Optional) The body of the call if required. Will access either a stringified object or an object. If an object passed, it will be stringified before entry.
 * 
 * @return  {Object}                {response, status}
 *
    import { shopifyApi } from '../helpers/shopify'

    shopifyApi('endpoint', 'POST', bodyObject, version, cartId).then(({response, status}) => {
        console.log(response, status);
    }).catch(error => console.error(error));
 */
async function shopifyApi(clientKey, instanceKey, endpoint, method, body) {
    const options = {
        method: method ? method : 'GET',
        credentials: 'same-origin',
        mode: 'same-origin'
    };
    
    if (body) {
        let bodyString = body;
        if (typeof body === 'object') {
        bodyString = JSON.stringify(body);
        }
    
        options.body = bodyString;
    }
    
    const encodedEndpoint = Buffer.from(endpoint).toString('base64');
    //   const userToken = getStorage('_loggedIn');
    
    if (!(typeof fetch === 'undefined')) {
        return await fetch(
        `/.netlify/functions/shopify?action=${encodedEndpoint}&client=${clientKey}&key=${instanceKey}`,
        options
        ).then(async res => ({ response: await parseJson(res), status: res.status }));
    } else {
        return { response: null, status: 404 }
    }
}

const getData = async (clientKey, instanceKey, endpoint, method, body) => {
    return await shopifyApi(clientKey, instanceKey, endpoint, method, body);
}

const getAllData = async (clientKey, instanceKey, endpoint, method, body, page = 1, data = []) => {
    const result = await shopifyApi(clientKey, instanceKey, `${endpoint}?limit=250&page=${page}`, method, body);
    // TODO: 
    // if (result.status === 200) {
    //     if (result.response.meta.pagination.total_pages > page) {
    //         return await getAllData(clientKey, instanceKey, endpoint, method, body, version, page + 1, [...data, ...result.response.data]);
    //     } else {
    //         return { response: [...data, ...result.response.data], status: 200 }
    //     }
    // }
}

/**
 * Define Data Types
 * @returns {Array}
 */

const dataTypes = () => {
    return [
        'Products',
        'Categories',
        'Pages',
        'Blog'
    ];
}

const transformData = (data) => {
    const object = {
      title: data.title,
      body: data.content,
    };
  
    if ('keywords' in data) {
      object.meta_keywords = data.keywords;
    }
  
    // if ('metaTitle' in data) {
    //   object.? = data.metaTitle;
    // }
  
    if ('metaDescription' in data) {
      object.meta_description = data.metaDescription;
    }
  
    return object;
  }

/**
 * Get Data from selected data type
 */

const getDataByType = async (clientKey, instanceKey, dataType) => {
    switch(dataType) {
        case 'Products':
            return await getAllData(clientKey, instanceKey, 'catalog/products');
        case 'Categories':
            return await getAllData(clientKey, instanceKey, 'catalog/trees/categories');
        case 'Pages':
            return await getAllData(clientKey, instanceKey, 'content/pages');
        case 'Blog':
            return await getAllData(clientKey, instanceKey, 'blog/posts');
        default:
            return { response: null, status: 404 }
    }
}

/**
 * Update data in platform
 */

const updateData = async (clientKey, instanceKey, dataType, data) => {
    let endpoint = '';
    let body = transformData(data);
    let method = 'id' in data ? 'PUT' : 'POST';
    switch(dataType) {
        case 'Products':
            endpoint = `catalog/products${'id' in data ? `/${data.id}` : ''}`;
            body = [transformData(data)];
            break;
        case 'Categories':
            endpoint = 'catalog/trees/categories';
            break;
        case 'Pages':
            endpoint = `content/pages${'id' in data ? `/${data.id}` : ''}`;
            break;
        case 'Blog':
            endpoint = `blog/posts${'id' in data ? `/${data.id}` : ''}`;
            break;
        default:
            endpoint = '';
            break;
    }

    if (endpoint !== '') {
        return await shopifyApi(clientKey, instanceKey, endpoint, method, body);
    } else {
        return { response: null, status: 404 }
    }
}

export { 
    getData,
    dataTypes,
    getDataByType,
    updateData
};
